import { Injectable, signal } from '@angular/core';
import { FieldOption, FieldOptions, LookupField } from '@nagel-types';
import { environment } from 'apps/nagel-cal-disposition/environment/environment';
import { BehaviorSubject } from 'rxjs';
import { branchesEndpoint } from 'apps/nagel-cal-disposition/src/app/configuration/consts/endpoints';
import { RequestService, StorageService } from '@nagel-services';
import { LOCAL_STORAGE_BRANCH_KEY } from '@nagel-consts';


const BRANCHES_AVAILABLE_ENDPOINT_PATH = environment.apiUrl + branchesEndpoint;

type Branch = {
    key: string;
    description: string;
};

@Injectable({
    providedIn: 'root'
})
export class BranchLookupService {
    branchOptionsSubject = new BehaviorSubject<LookupField>(new LookupField({}));
    branchOptionsObservable$ = this.branchOptionsSubject.asObservable();

    private branchSelectionChangedSubject = new BehaviorSubject<number>(0);
    branchSelectionChangedObservable$ = this.branchSelectionChangedSubject.asObservable();

    branchSelectedValue = signal<string>('');
    branchOptions = signal<FieldOption[]>([]);

    constructor(
        private storageService: StorageService,
        private requestService: RequestService
    ) { }

    options: FieldOption[] = [];

    getAvailableBranches = () => {
        this.requestService.getRequest<unknown, Branch[]>(BRANCHES_AVAILABLE_ENDPOINT_PATH).subscribe((response: Branch[]) => {
            this.options = response.map((branch) => ({ value: branch.key, viewValue: branch.description }));

            this.branchOptionsSubject.next(new LookupField(this.getLookupBranchConfig()));
            this.branchOptions.set(this.options);
            this.branchSelectedValue.set(this.getInitalOption()?.value as string);
        });
    };

    getCurrentBranch() {
        let branch = this.storageService.getItem(LOCAL_STORAGE_BRANCH_KEY) || '{}';
        const isValidBranch = this.options.some((option) => JSON.parse(branch)?.value === option.value);

        if (!branch || !isValidBranch) {
            this.storageService.removeItem(LOCAL_STORAGE_BRANCH_KEY);
            this.storageService.saveItem(LOCAL_STORAGE_BRANCH_KEY, JSON.stringify(this.options[0]));

            branch = JSON.stringify(this.options[0]);
        }

        return JSON.parse(branch);
    }

    getInitalOption = () => {
        let initalOption = this.getCurrentBranch();

        if (!initalOption && this.options.length > 0) {
            initalOption = this.options[0];
            this.storageService.saveItem(LOCAL_STORAGE_BRANCH_KEY, JSON.stringify(this.options[0]));
        }

        return initalOption;
    };

    onChangeHandler(event: any) {
        const currentBranch = {
            value: event.value,
            viewValue: this.options.find((item) => item.value === event.value)?.viewValue
        };
        this.storageService.saveItem(
            LOCAL_STORAGE_BRANCH_KEY,
            JSON.stringify(currentBranch)
        );
        this.branchSelectedValue.set(currentBranch.value as string);
        this.branchSelectionChangedSubject.next(this.branchSelectionChangedSubject.value + 1);
    }

    getLookupBranchConfig(): FieldOptions<string> {
        return {
            key: 'branch',
            label: 'Branch',
            value: this.getInitalOption()?.value || '',
            icon: 'warehouse_icon',
            className: 'lg:col-span-1 col-span-2 pt:2px',
            options: this.options,
            onChange: (event) => {
                const currentBranch = {
                    value: event.value,
                    viewValue: this.options.find((item) => item.value === event.value)?.viewValue
                };
                this.storageService.saveItem(
                    LOCAL_STORAGE_BRANCH_KEY,
                    JSON.stringify(currentBranch)
                );
                this.branchSelectedValue.set(currentBranch.value as string);
                this.branchSelectionChangedSubject.next(this.branchSelectionChangedSubject.value + 1);


                //this.filterService.resetFilters();
            }
        };
    }
}